import styled from 'styled-components'
import { colors } from 'client/styles'

export const ListItemBase = styled.div`
  display: flex;
  padding-block-end: 16px;
`

export const IconWrapper = styled.div`
  svg {
    fill: ${colors.grey2};
  }
`

export const ContentWrapper = styled.div`
  padding-inline-start: 8px;
  line-height: 150%;
  color: ${colors.grey2};
`
